import { Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './Layout.jsx'
import { trackPageView } from './utils/index.js'

// Admin
import { AdminAuthProvider } from './admin/context/AdminAuthContext.jsx'
import ProtectedAdminRoute from './admin/components/ProtectedAdminRoute.jsx'
import AdminLayout from './admin/components/AdminLayout.jsx'
import AdminDashboard from './admin/pages/AdminDashboard.jsx'
import AdminProducts from './admin/pages/AdminProducts.jsx'
import AdminProductForm from './admin/pages/AdminProductForm.jsx'
import AdminOrders from './admin/pages/AdminOrders.jsx'
import AdminOrderDetail from './admin/pages/AdminOrderDetail.jsx'
import AdminCustomers from './admin/pages/AdminCustomers.jsx'
import AdminAnalytics from './admin/pages/AdminAnalytics.jsx'
import AdminDiscounts from './admin/pages/AdminDiscounts.jsx'
import AdminSettings from './admin/pages/AdminSettings.jsx'

import Home from './pages/Home.jsx'
import './styles/globals.css'
import About from './pages/About.jsx'
import Products from './pages/Products.jsx'
import ProductDetail from './pages/ProductDetail.jsx'
import Account from './pages/Account.jsx'
import Newsletter from './pages/Newsletter.jsx'
import Apparel from './pages/Apparel.jsx'
import Cart from './pages/Cart.jsx'

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (!isAdmin) trackPageView(location.pathname);
  }, [location.pathname, isAdmin]);

  if (isAdmin) {
    return (
      <ProtectedAdminRoute>
        <AdminLayout>
          <Routes>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/orders/:id" element={<AdminOrderDetail />} />
            <Route path="/admin/products" element={<AdminProducts />} />
            <Route path="/admin/products/new" element={<AdminProductForm />} />
            <Route path="/admin/products/:id/edit" element={<AdminProductForm />} />
            <Route path="/admin/customers" element={<AdminCustomers />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/discounts" element={<AdminDiscounts />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
          </Routes>
        </AdminLayout>
      </ProtectedAdminRoute>
    );
  }

  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/account" element={<Account />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/apparel" element={<Apparel />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <AppRoutes />
    </AdminAuthProvider>
  )
}

export default App